var React = require('react');

function ShortcutDarkInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"18","height":"24","rx":"4","fill":"white","fillOpacity":"0.12","key":0}),React.createElement("path",{"d":"M11.9019 6L7.37793 18.1357H6L10.5239 6H11.9019Z","fill":"white","fillOpacity":"0.5","key":1}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"17","height":"23","rx":"3.5","stroke":"#D9D9E2","strokeOpacity":"0.5","key":2})]);
}

ShortcutDarkInline.defaultProps = {"width":"18","height":"24","viewBox":"0 0 18 24","fill":"none"};

module.exports = ShortcutDarkInline;

ShortcutDarkInline.default = ShortcutDarkInline;
